/**
 * Suggestion (Ghosts) UI store.
 *
 * The ghost candidates themselves come from the ghosts engine (src/lib/ghosts,
 * suggestNextChords) via SuggestionsLayer. This store only holds the hover index
 * and the on/off flag, so ghosts can be turned off. (The old canvas-store
 * subscription + grammar recompute lived here; it drove nothing once the live
 * canvas moved to App's React state, so it was removed.)
 */
import { create } from 'zustand';

interface SuggestionState {
  hoveredIndex: number | null;
  isEnabled: boolean;
  setHovered: (index: number | null) => void;
  setEnabled: (enabled: boolean) => void;
}

export const useSuggestionStore = create<SuggestionState>()((set) => ({
  hoveredIndex: null,
  isEnabled: true,
  setHovered: (index) => set({ hoveredIndex: index }),
  setEnabled: (enabled) =>
    set(enabled ? { isEnabled: true } : { isEnabled: false, hoveredIndex: null }),
}));

/** Hook to check whether ghost suggestions are enabled. */
export function useSuggestionsEnabled(): boolean {
  return useSuggestionStore((state) => state.isEnabled);
}
